import React from 'react';
import type { GeneralConfig } from '../types';

interface GeneralSettingsTabProps {
  config: GeneralConfig;
  onChange: (config: GeneralConfig) => void;
}

const GeneralSettingsTab: React.FC<GeneralSettingsTabProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900 mb-4">Configuración General</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nombre de la empresa
            </label>
            <input
              type="text"
              value={config.companyName}
              onChange={(e) => onChange({ ...config, companyName: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email de soporte
            </label>
            <input
              type="email"
              value={config.supportEmail}
              onChange={(e) => onChange({ ...config, supportEmail: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Zona horaria del sistema
            </label>
            <select
              value={config.systemTimezone}
              onChange={(e) => onChange({ ...config, systemTimezone: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="Europe/Madrid">Europa/Madrid</option>
              <option value="Europe/London">Europa/Londres</option>
              <option value="America/New_York">América/Nueva York</option>
              <option value="America/Los_Angeles">América/Los Ángeles</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Moneda por defecto
            </label>
            <select
              value={config.defaultCurrency}
              onChange={(e) => onChange({ ...config, defaultCurrency: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="EUR">EUR (€)</option>
              <option value="USD">USD ($)</option>
              <option value="GBP">GBP (£)</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralSettingsTab;
